import React, { Component } from "react";
import { connect } from "react-redux";
import compose from "ramda/src/compose";
import Loader from "../../Loading";
import { queryOpenReason } from "../../../services/state/actions";

class QueryOpenReason extends Component {
  componentWillMount() {
    const { queryOpenReason, onNextStep } = this.props;

    queryOpenReason(() => {
      onNextStep();
    });
  }

  render() {
    return <Loader isOpen={this.props.loading} />;
  }
}

const enhance = compose(connect(null, { queryOpenReason }));

export default enhance(QueryOpenReason);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/QueryOpenReason.js